import React, { useEffect, useState } from "react";
import './styles.css'
import CommonScreenContent from "../../../components/screen/common-screen-content/commonScreenContent";
import ScreenLabel from "../../../components/label/screen-label/screenLabel";
import Loader from '../../../components/loader/loader.component'
import { ToastContainer } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useLocation } from 'react-router-dom';
import Select from 'react-select'
import { displayErrorToast, displaySuccessToast, isEmpty, isLoggedInUserBusiness, isLoggedInUserEmployee, isNull, removeSpecialCharAndChangeToPascal } from "../../../utils/Utils";
import { userBusinessListRequest } from '../../../redux/business/business.action'
import { businessLocationListRequest } from '../../../redux/business-location/businessLocation.action'
import { employeeListRequest } from '../../../redux/employee/employee.action'
import { requestListReq, requestDetailReq, updateRequestStatusReq, updateRequestStatusReStatus } from '../../../redux/request/request.action'
import { API_CONSTANTS, APP_CONSTANTS, ROUTES } from "../../../utils/AppConstants";
import moment from "moment";
import FormFieldLabel from "../../../components/label/form-field-label/formFieldLabel";
import CommonInputRow from "../../../components/input/common-input-row/commonInputRow";
import Modal from 'react-bootstrap/Modal';
import CommonInputFloatFull from "../../../components/input/common-input-float-full/commonInputFloatFull";
import { checkFunctionalityPermission, PERMISSION_SUB_TYPE, PERMISSION_TYPE } from "../../../utils/PermissionUtil";

const RequestList = props => {
    const { user, employeeSelectedBusiness, employeeSelectedLocation } = useSelector(state => state.user)
    const [isLoading, setLoading] = useState(false)
    const dispatch = useDispatch()
    let navigate = useNavigate();
    const { userBusinessListSuccess, userBusinessListError } = useSelector(state => state.business)
    const { businessLocationListSuccess, businessLocationListError } = useSelector(state => state.businessLocation)
    const { requestListSuccess, requestListError, requestDetailSuccess, requestDetailError,
        updateRequestStatusSuccess, updateRequestStatusError, updateRequestStatusReqStatus
    } = useSelector(state => state.request)
    const { employeeListSuccess, employeeListError } = useSelector(state => state.employee)
    const [selectedBusiness, setSelectedBusiness] = useState()
    const [selectedLocation, setSelectedLocation] = useState()
    const PENDING_STATUS = { key: APP_CONSTANTS.EMPLOYEE_REQUEST_STATUS_TYPE.PENDING, value: removeSpecialCharAndChangeToPascal(APP_CONSTANTS.EMPLOYEE_REQUEST_STATUS_TYPE.PENDING) }
    const REQUEST_STATUS_LIST = [
        PENDING_STATUS,
        { key: APP_CONSTANTS.EMPLOYEE_REQUEST_STATUS_TYPE.APPROVED, value: removeSpecialCharAndChangeToPascal(APP_CONSTANTS.EMPLOYEE_REQUEST_STATUS_TYPE.APPROVED) },
        { key: APP_CONSTANTS.EMPLOYEE_REQUEST_STATUS_TYPE.REJECTED, value: removeSpecialCharAndChangeToPascal(APP_CONSTANTS.EMPLOYEE_REQUEST_STATUS_TYPE.REJECTED) },
        { key: 'MY_TEAM', value: removeSpecialCharAndChangeToPascal('MY_TEAM') },
    ]
    const [selectedStatus, setSelectedStatus] = useState(PENDING_STATUS)
    const [selectedRequest, setSelectedRequest] = useState()
    const [showRequestDetailModal, setShowRequestDetailModal] = useState(false)
    const [showRejectModal, setShowRejectModal] = useState(false)
    const [rejectReason, setRejectReason] = useState('')

    useEffect(() => {
        if (isLoggedInUserBusiness(user)) {
            sessionStorage.setItem(APP_CONSTANTS.SCREEN.REQUEST_LIST, true)
            fetchBusinessList()
        }
    }, [])

    const fetchBusinessList = () => {
        setLoading(true)
        const data = {
            userId: user.data.userDetails.userId
        }
        dispatch(userBusinessListRequest(data))
    }

    const fetchRequestList = () => {
        setLoading(true)
        const data = {}
        if (isLoggedInUserBusiness(user) && !isEmpty(selectedBusiness) && !isEmpty(selectedLocation)) {
            data.businessId = selectedBusiness.businessId
            data.locationId = selectedLocation.locationId
        }
        if (isLoggedInUserEmployee(user) && !isEmpty(employeeSelectedBusiness) && !isEmpty(employeeSelectedLocation)) {
            data.businessId = employeeSelectedBusiness
            data.locationId = employeeSelectedLocation
        }
        data.status = selectedStatus.key
        dispatch(requestListReq(data))
    }

    const fetchBusinessLocation = () => {
        if (!isEmpty(selectedBusiness)) {
            setLoading(true)
            dispatch(businessLocationListRequest(selectedBusiness.businessId))
        }
    }

    useEffect(() => {
        if (!isEmpty(userBusinessListSuccess)) {
            setLoading(false)
            if (sessionStorage.getItem(APP_CONSTANTS.SCREEN.REQUEST_LIST) === 'true') {
                sessionStorage.setItem(APP_CONSTANTS.SCREEN.REQUEST_LIST, false)
                setSelectedBusiness(userBusinessListSuccess.data[0])
            }
        } else if (!isEmpty(userBusinessListError)) {
            setLoading(false)
        }
    }, [userBusinessListSuccess, userBusinessListError])

    useEffect(() => {
        if (!isEmpty(businessLocationListSuccess)) {
            setLoading(false)
            setSelectedLocation(businessLocationListSuccess.data[0])
        } else if (!isEmpty(businessLocationListError)) {
            setLoading(false)
        }
    }, [businessLocationListSuccess, businessLocationListError])

    useEffect(() => {
        if (!isEmpty(requestListSuccess)) {
            setLoading(false)
        } else if (!isEmpty(requestListError)) {
            setLoading(false)
        }
    }, [requestListSuccess, requestListError])

    useEffect(() => {
        if (!isEmpty(requestDetailSuccess)) {
            setLoading(false)
        } else if (!isEmpty(requestDetailError)) {
            setLoading(false)
        }
    }, [requestDetailSuccess, requestDetailError])

    useEffect(() => {
        if (!isEmpty(employeeListSuccess)) {
            setLoading(false)
        } else if (!isEmpty(employeeListError)) {
            setLoading(false)
        }
    }, [employeeListSuccess, employeeListError])

    useEffect(() => {
        if (updateRequestStatusReqStatus === API_CONSTANTS.SUCCESS_STATUS) {
            setLoading(false)
            displaySuccessToast(updateRequestStatusSuccess.data.message)
            fetchRequestList()
        } else if (updateRequestStatusReqStatus === API_CONSTANTS.ERROR_STATUS) {
            setLoading(false)
            displayErrorToast(updateRequestStatusError.message)
        }
        if (updateRequestStatusReqStatus?.length) {
            dispatch(updateRequestStatusReStatus(''))
        }
    }, [updateRequestStatusSuccess, updateRequestStatusError, updateRequestStatusReqStatus])

    useEffect(() => {
        if (isLoggedInUserBusiness(user) === true && !isNull(selectedBusiness)) {
            fetchBusinessLocation()
        }
    }, [selectedBusiness])

    useEffect(() => {
        if (!isNull(selectedLocation) && isLoggedInUserBusiness(user)) {
            fetchRequestList()
        }
    }, [selectedLocation])

    useEffect(() => {
        if (!isEmpty(selectedStatus)) {
            if (selectedStatus.key !== 'MY_TEAM') {
                fetchRequestList()
            } else {
                fetchEmployeeList()
            }
        }
    }, [selectedStatus])

    const fetchEmployeeList = () => {
        setLoading(true)
        const data = {}
        if (isLoggedInUserBusiness(user)) {
            data.supervisorId = user.data.userDetails.userId
            data.supervisorType = user.data.userDetails.userType
        } else if (isLoggedInUserEmployee(user)) {
            data.supervisorId = user.data.userDetails.employeeId
            data.supervisorType = user.data.userDetails.userType
        }
        dispatch(employeeListRequest(data))
    }

    const handleCreateRequestClick = () => {
        navigate(ROUTES.requests.add)
    }

    const getStatusClassName = (e, selectedStatus) => {
        if (e.key === APP_CONSTANTS.EMPLOYEE_REQUEST_STATUS_TYPE.PENDING) {
            if (selectedStatus.key === APP_CONSTANTS.EMPLOYEE_REQUEST_STATUS_TYPE.PENDING) {
                return 'tl-status-item tl-status-item-selected-blue'
            } else {
                return 'tl-status-item'
            }
        } else if (e.key === APP_CONSTANTS.EMPLOYEE_REQUEST_STATUS_TYPE.APPROVED) {
            if (selectedStatus.key === APP_CONSTANTS.EMPLOYEE_REQUEST_STATUS_TYPE.APPROVED) {
                return 'tl-status-item tl-status-item-selected-green'
            } else {
                return 'tl-status-item'
            }
        } else if (e.key === APP_CONSTANTS.EMPLOYEE_REQUEST_STATUS_TYPE.REJECTED) {
            if (selectedStatus.key === APP_CONSTANTS.EMPLOYEE_REQUEST_STATUS_TYPE.REJECTED) {
                return 'tl-status-item tl-status-item-selected-red'
            } else {
                return 'tl-status-item'
            }
        } else {
            if (selectedStatus.key === 'MY_TEAM') {
                return 'tl-status-item tl-status-item-selected-dark-green'
            } else {
                return 'tl-status-item'
            }
        }
    }

    const handleViewDetail = item => {
        setSelectedRequest(item)
        setShowRequestDetailModal(true)
    }

    const handleEmployeeRequestDetail = (element) => {
        navigate(ROUTES.requests.employeeRequest, {
            state: {
                requestorId: element.employeeId,
                businessId: isLoggedInUserBusiness(user) ? selectedBusiness.businessId : employeeSelectedBusiness,
                locationId: isLoggedInUserBusiness(user) ? selectedLocation.locationId : employeeSelectedLocation
            }
        })
    }

    const handleRequestUpdateStatusClick = (status) => {
        if (isEmpty(selectedRequest)) {
            displayErrorToast('Something went wrong. Please try again')
        } else if (status === APP_CONSTANTS.EMPLOYEE_REQUEST_STATUS_TYPE.REJECTED && isEmpty(rejectReason)) {
            displayErrorToast('Request reject reason cannot be blank')
        } else {
            setLoading(true)
            const data = {
                requestId: selectedRequest.requestId,
                status: status
            }
            if (status === APP_CONSTANTS.EMPLOYEE_REQUEST_STATUS_TYPE.REJECTED) {
                data.rejectReason = rejectReason
            }
            dispatch(updateRequestStatusReq(data))
            setShowRequestDetailModal(false)
            setShowRejectModal(false)
        }
    }

    const getDetailStatusClassname = (status) => {
        if (status === APP_CONSTANTS.EMPLOYEE_REQUEST_STATUS_TYPE.PENDING) {
            return 'pd-status-container pd-status-container-blue'
        } else if (status === APP_CONSTANTS.EMPLOYEE_REQUEST_STATUS_TYPE.APPROVED) {
            return 'pd-status-container pd-status-container-complete'
        } else if (status === APP_CONSTANTS.EMPLOYEE_REQUEST_STATUS_TYPE.REJECTED) {
            return 'pd-status-container pd-status-container-cancelled'
        }
    }

    const isPermissionAllowed = (pType) => {
        if (pType === PERMISSION_SUB_TYPE.REQUEST.ACCEPT_REJECT_REQUEST) {
            return checkFunctionalityPermission(user, PERMISSION_TYPE.REQUEST, PERMISSION_SUB_TYPE.REQUEST.ACCEPT_REJECT_REQUEST, employeeSelectedBusiness, employeeSelectedLocation)
        }
    }

    return (
        <>
            <CommonScreenContent>
                <ScreenLabel label='Requests' />
                {isLoggedInUserBusiness(user) === true && <CommonInputRow>
                    <div className="select-half-width">
                        <FormFieldLabel className='up-bold-label' label='Select Business' />
                        {!isEmpty(userBusinessListSuccess) && !isEmpty(userBusinessListSuccess.data) && <Select
                            className='select-full-width-no-border'
                            value={selectedBusiness}
                            getOptionLabel={e => e.businessName}
                            getOptionValue={e => e}
                            options={userBusinessListSuccess.data}
                            placeholder='Select Business'
                            onChange={e => setSelectedBusiness(e)} />}
                        {!isEmpty(userBusinessListError) && <div className="p-text">{userBusinessListError.message}</div>}
                    </div>
                    {!isEmpty(selectedBusiness) && <div className="select-half-width">
                        <FormFieldLabel className='up-bold-label' label='Select Location' />
                        {!isEmpty(businessLocationListSuccess) && !isEmpty(businessLocationListSuccess.data) && <Select
                            className='select-full-width-no-border'
                            value={selectedLocation}
                            getOptionLabel={e => e.name}
                            getOptionValue={e => e}
                            options={businessLocationListSuccess.data}
                            placeholder='Select Location'
                            onChange={e => setSelectedLocation(e)} />}
                        {!isEmpty(businessLocationListError) && <div className="p-text">{businessLocationListError.message}</div>}
                    </div>}
                </CommonInputRow>}
                <div className="tl-status-row-container">
                    {!isEmpty(REQUEST_STATUS_LIST) && <div className="tl-status-parent-container">
                        <div className="tl-status-container">
                            {REQUEST_STATUS_LIST.map(e => (
                                <div className={getStatusClassName(e, selectedStatus)} onClick={() => setSelectedStatus(e)}>{e.value}</div>
                            ))}
                        </div>
                    </div>}
                </div>
                {!isEmpty(selectedStatus) && selectedStatus.key !== 'MY_TEAM' && !isNull(requestListSuccess) && !isEmpty(requestListSuccess.data) && <div className="table-scroll-container">
                    <table class="table table-hover mt-4">
                        <thead>
                            <tr>
                                <th scope="col">Name</th>
                                <th scope="col" className="text-center">Employee Id</th>
                                <th scope="col" className="text-center">Request Type</th>
                                <th scope="col" className="text-center">Date</th>
                                <th scope="col" className="text-center">Status</th>
                                <th scope="col" className="text-center">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {requestListSuccess.data.map(element => (
                                <tr className="loc-table-row-container">
                                    <td>{element.requestorDetails?.firstName} {element.requestorDetails?.lastName}</td>
                                    <td className="text-center">{element.requestorDetails?.userType === APP_CONSTANTS.USER_ROLE_TYPE.EMPLOYEE ? !isEmpty(element.requestorDetails?.employeeBusinessMapping[0]?.employeeCode) ? element.requestorDetails.employeeBusinessMapping[0].employeeCode : '-' : removeSpecialCharAndChangeToPascal(element.requestorDetails.userType)}</td>
                                    <td className="text-center">{removeSpecialCharAndChangeToPascal(element.requestType)}</td>
                                    <td className="text-center">{moment.utc(element.requestDate).local().format('DD/MM/YYYY')}</td>
                                    <td className="text-center">{removeSpecialCharAndChangeToPascal(element.status)}</td>
                                    <td className="text-center">
                                        <div className="loc-list-button-container">
                                            <div className="loc-list-button" onClick={() => { handleViewDetail(element) }}><div className="tr-action-btn">View Details</div></div>
                                        </div>
                                    </td>
                                </tr>
                            ))}

                        </tbody>
                    </table>
                </div>}
                {!isEmpty(selectedStatus) && selectedStatus.key !== 'MY_TEAM' && !isEmpty(requestListError) && <div className="content-error">{requestListError.message}</div>}
                {!isEmpty(selectedStatus) && selectedStatus.key === 'MY_TEAM' && !isNull(employeeListSuccess) && !isEmpty(employeeListSuccess.data) && <div className="table-scroll-container">
                    <table class="table table-hover mt-4">
                        <thead>
                            <tr>
                                <th scope="col">Name</th>
                                <th scope="col" className="text-center">Employee Code</th>
                                <th scope="col" className="text-center">Personal Email</th>
                                <th scope="col" className="text-center">Mobile</th>
                                <th scope="col" className="text-center">Supervisor</th>
                                <th scope="col" className="text-center">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {employeeListSuccess.data.map(element => (
                                <tr className="loc-table-row-container">
                                    <td>{element.firstName} {element.lastName}</td>
                                    <td className="text-center">{element.userType === APP_CONSTANTS.USER_ROLE_TYPE.EMPLOYEE ? element.employeeBusinessMapping[0].employeeCode : removeSpecialCharAndChangeToPascal(element.userType)}</td>
                                    <td className="text-center">{element.personalEmail}</td>
                                    <td className="text-center">+{element.mobile}</td>
                                    <td className="text-center">{!isEmpty(element.employeeBusinessMapping[0]?.supervisorDetail) ? `${element.employeeBusinessMapping[0].supervisorDetail.firstName} ${element.employeeBusinessMapping[0].supervisorDetail.lastName}` : '-'}</td>
                                    <td className="text-center">
                                        <div className="loc-list-button-container">
                                            <div className="loc-list-button" onClick={() => { handleEmployeeRequestDetail(element) }}><div className="tr-action-btn">View Requests</div></div>
                                        </div>
                                    </td>
                                </tr>
                            ))}

                        </tbody>
                    </table>
                </div>}
                {!isEmpty(selectedStatus) && selectedStatus.key === 'MY_TEAM' && !isEmpty(employeeListError) && <div className="content-error">{employeeListError.message}</div>}
                <div className="vl-fab-container" onClick={() => handleCreateRequestClick()}>
                    <img src={require('../../../assets/plus_icon.png')} className="vl-fab-icon" />
                </div>
            </CommonScreenContent>
            <Modal
                onHide={() => { setShowRequestDetailModal(false) }}
                show={showRequestDetailModal}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        Request Details
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {!isEmpty(selectedRequest) && <div>
                        <div className={getDetailStatusClassname(selectedRequest.status)}>{removeSpecialCharAndChangeToPascal(selectedRequest.status)}</div>
                        <div className="rl-detail-name-label">{selectedRequest.requestorDetails?.firstName} {selectedRequest.requestorDetails?.lastName}</div>
                        <div className="rl-detail-id-label">{!isEmpty(selectedRequest.requestorDetails?.employeeBusinessMapping[0].employeeCode) ? selectedRequest.requestorDetails.employeeBusinessMapping[0].employeeCode : ''}</div>
                        <FormFieldLabel label='Request Details' />
                        <div className="rl-detail-type-label">Request Type: {removeSpecialCharAndChangeToPascal(selectedRequest.requestType)}</div>
                        <div className="rl-detail-date-label">Request Date: {moment.utc(selectedRequest.requestDate).local().format('DD/MM/YYYY')}</div>
                        <div className="rl-detail-description-label">{selectedRequest.description}</div>
                        {isLoggedInUserBusiness(user) && selectedRequest.status === APP_CONSTANTS.EMPLOYEE_REQUEST_STATUS_TYPE.PENDING && <div className="at-modal-btn-container">
                            <div className="at-modal-no-btn" onClick={() => {
                                setShowRequestDetailModal(false)
                                setShowRejectModal(true)
                            }}>REJECT</div>
                            <div className="at-modal-yes-btn" onClick={() => { handleRequestUpdateStatusClick(APP_CONSTANTS.EMPLOYEE_REQUEST_STATUS_TYPE.APPROVED) }}>APPROVE</div>
                        </div>}
                    </div>}
                </Modal.Body>
            </Modal>
            <Modal
                onHide={() => { setShowRejectModal(false) }}
                show={showRejectModal}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        Reject Request
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <CommonInputFloatFull
                        type='text'
                        id='rejectReason'
                        onChange={e => setRejectReason(e.target.value)}
                        placeholder='Reason'
                        value={rejectReason}
                        rows={2}
                        multiline={true}
                    />
                    <div className="at-modal-btn-container">

                        <div className="at-modal-no-btn" onClick={() => { handleRequestUpdateStatusClick(APP_CONSTANTS.EMPLOYEE_REQUEST_STATUS_TYPE.REJECTED) }}>CONFIRM</div>
                    </div>
                </Modal.Body>
            </Modal>
            <ToastContainer />
            <Loader active={isLoading} text='Please wait...' />

        </>
    )
}

export default RequestList